document.addEventListener("DOMContentLoaded", () => {
  const accordionBtns = document.querySelectorAll(".accordion");

  accordionBtns.forEach((accordion) => {
    accordion.onclick = function () {

      accordionBtns.forEach((innerAccordion) => {
        if (this !== innerAccordion) {
          innerAccordion.classList.remove("is-open");
          innerAccordion.nextElementSibling.classList.remove("is-open");
          innerAccordion.nextElementSibling.style.maxHeight = null;
        }
      })

      this.classList.toggle("is-open");
  
      const content = this.nextElementSibling;

      content.classList.toggle("is-open");
  
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 10 + "px";
      }
    };
  });
});